// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'semantic-ui-react';
import _ from 'lodash';
// local
import { formatNumber } from 'app/lib/helper';
// views
import EmptyList from 'app/ui/commons/emptyList/EmptyList';

class ReportSupplier extends Component {
    renderEmpty = () => <EmptyList emptyMessage="Não foram encontradas informações para o filtro configurado." />;

    renderTable(data, onClickSave) {
        const { dateFrom, dateTo, supplier, replacements, totalCylindersQtd, totalVolume, totalPrice, totalCylindersReturned, totalPriceReturned } = data;
        return (
            <React.Fragment>
                <div className="report">
                    <div className="date">
                        <span className="bold">Período:</span> {dateFrom} à {dateTo}
                    </div>
                    <div className="header">
                        <div className="title">
                            SALVUS ATAS | Relatório de reposição de cilindros e consumo de O<sub>2</sub>
                        </div>
                        <div className="content">
                            <div>
                                Fornecedor: <span className="bold wrap">{supplier.name}</span>
                            </div>
                            <div>
                                Email: <span className="bold wrap">{supplier.email}</span>
                            </div>
                            <div>
                                CNPJ: <span className="bold">{supplier.cnpj}</span>
                            </div>
                            <div>
                                Telefone Principal: <span className="bold">{supplier.phone1}</span>
                            </div>
                            <div>
                                Telefone Extra: <span className="bold">{supplier.phone2}</span>
                            </div>
                        </div>
                    </div>
                    <div className="body">
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>PACIENTE</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        TIPO DE CILINDRO (M<sup>3</sup>)
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">CILINDROS ENTREGUES</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        VOLUME (M<sup>3</sup>)
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">VALOR (R$)</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {_.map(replacements, rep => {
                                    const key = _.uniqueId('patient');
                                    return (
                                        <Table.Row key={key}>
                                            <Table.Cell className="wrap">{rep.patient}</Table.Cell>
                                            <Table.Cell textAlign="center">{rep.type}</Table.Cell>
                                            <Table.Cell textAlign="center">{rep.cylinders}</Table.Cell>
                                            <Table.Cell textAlign="center">{formatNumber(rep.volume)}</Table.Cell>
                                            <Table.Cell textAlign="center">{formatNumber(rep.price)}</Table.Cell>
                                        </Table.Row>
                                    );
                                })}
                                <Table.Row>
                                    <Table.Cell colSpan="2">
                                        <span className="italic">CILINDROS DEVOLVIDOS: </span>
                                        <span className="bold">{totalCylindersReturned}</span>
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" />
                                    <Table.Cell textAlign="center" />
                                    <Table.Cell textAlign="center">{formatNumber(-1 * totalPriceReturned)}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                            <Table.Footer>
                                <Table.Row>
                                    <Table.Cell>TOTAL NO PERÍODO</Table.Cell>
                                    <Table.Cell />
                                    <Table.Cell textAlign="center">{totalCylindersQtd}</Table.Cell>
                                    <Table.Cell textAlign="center">
                                        {formatNumber(totalVolume)} m<sup>3</sup>
                                    </Table.Cell>
                                    <Table.Cell textAlign="center">R$ {formatNumber(totalPrice)}</Table.Cell>
                                </Table.Row>
                            </Table.Footer>
                        </Table>
                    </div>
                </div>
                <Button className="btn-save" onClick={onClickSave}>
                    Salvar PDF
                </Button>
            </React.Fragment>
        );
    }

    render() {
        const { onClickSave, data } = this.props;
        return _.isEmpty(data.replacements) ? this.renderEmpty() : this.renderTable(data, onClickSave);
    }
}
ReportSupplier.propTypes = {
    data: PropTypes.object,
    onClickSave: PropTypes.func,
};
export default ReportSupplier;
